var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38923 0.733334C3.49723 0.490001 3.7379 0.333334 4.00456 0.333334H9.32256C9.82256 0.333334 10.1486 0.860001 9.92456 1.308L8.4119 4.33333H10.6506C11.2506 4.33333 11.5506 5.05867 11.1266 5.48267L3.1579 13.4513C2.65523 13.954 1.8179 13.4367 2.04323 12.7627L3.7419 7.66667H1.34323C1.23106 7.66666 1.12067 7.63864 1.02208 7.58513C0.923493 7.53163 0.839835 7.45434 0.778704 7.36029C0.717572 7.26624 0.680905 7.15841 0.672032 7.0466C0.663159 6.93478 0.682362 6.82251 0.727897 6.72L3.38923 0.733334Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoApply);
export default __webpack_public_path__ + "static/media/auto-apply.428eaa2f058199b6faa8bcd639046100.svg";
export { ForwardRef as ReactComponent };